import { connect } from 'react-redux';

import ConnectionErrorBanner from 'presentation/components/ConnectionErrorBanner';
import reconnectChatClient from 'actions/app/reconnectChatClient';

export const mapDispatchToProps = dispatch => {
  return {
    onClick: () => dispatch(reconnectChatClient),
  };
};

const ConnectionErrorBannerContainer = connect(
  null,
  mapDispatchToProps
)(ConnectionErrorBanner);

export default ConnectionErrorBannerContainer;
